{
  "logout": "登出",
  "logoutHeader": "登出",
  "logoutQuestion": "確定登出系統嗎?",
  "theme": "主題樣式",
  "accMgmt": "帳號管理",
  "reload": "重新載入",
  "language": "Language",
  "idleHint": "閒置倒數,歸零自動登出"
}